module.exports = __webpack_public_path__ + "static/media/event-accent-light.1ce65a34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event-accent-light.svg
// module id = 697
// module chunks = 0